import type { EvidencePolicyDto, EvidenceUploadRequestDto } from "./cmtsContractTypes.js";
import { createDiagnostic } from "./cmtsApiErrors.js";
import type { ComponentDiagnostic } from "@swot/base-components";

export type EvidenceFileValidationResult = { ok: boolean; diagnostics: readonly ComponentDiagnostic[] };

export function validateEvidenceFile(file: File, policy?: Partial<EvidencePolicyDto> | null): EvidenceFileValidationResult {
  const diagnostics: ComponentDiagnostic[] = [];
  if (!file) diagnostics.push(createDiagnostic("CMTS_EVIDENCE_FILE_MISSING", "Evidence file is required."));
  const max = policy?.maxFileSizeBytes;
  if (typeof max === "number" && max > 0 && file.size > max) {
    diagnostics.push(createDiagnostic("CMTS_EVIDENCE_FILE_TOO_LARGE", `File size ${file.size} bytes exceeds active policy limit ${max} bytes.`, "error", "file"));
  }
  const allowed = policy?.allowedMimeTypes;
  if (allowed?.length && file.type && !allowed.includes(file.type)) {
    diagnostics.push(createDiagnostic("CMTS_EVIDENCE_MIME_BLOCKED", `MIME type ${file.type} is not allowed by the active evidence policy.`, "error", "file"));
  }
  if (!file.name?.trim()) diagnostics.push(createDiagnostic("CMTS_EVIDENCE_FILENAME_MISSING", "Original filename is required for audit traceability.", "error", "file"));
  return { ok: diagnostics.length === 0, diagnostics };
}

export function buildEvidenceForm(file: File, request: EvidenceUploadRequestDto): FormData {
  const form = new FormData();
  form.append("file", file, file.name);
  for (const [key, value] of Object.entries(request)) {
    if (value !== undefined && value !== null) form.append(key, typeof value === "boolean" ? String(value) : String(value));
  }
  return form;
}

export function safeDownloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = fileName || "cmts-download";
    anchor.rel = "noopener";
    anchor.click();
  } finally {
    URL.revokeObjectURL(url);
  }
}
